export enum TrackingEvent {
  SelectProperty = `[mp-query-builder] Select Property`,
  SelectPropertiesDropdownOption = `[mp-query-builder] Select properties dropdown option`,
  ExpandedSection = `[mp-query-builder] Expanded Section`,
  CreateInlineCohort = `[mp-query-builder] Created Inline Cohort`,
  EditInlineCohorts = `[mp-query-builder] Edit Inline Cohort`,
  SaveInlineCohorts = `[mp-query-builder] Save Inline Cohort`,
  OpenInlineCohortsModal = `[mp-query-builder] Opened Inline Cohorts Modal`,
  OpenPropertiesDropDown = `[mp-query-builder] Opened Properties Dropdown`,
  CreateCustomProperty = `[mp-query-builder] Custom Property - create`,
  EditCustomProperty = `[mp-query-builder] Custom Property - edit`,
  ShowHiddenEntity = `[Lexicon] Show Hidden Entities`,
  MenuLoadedRAF = `[ui-perf] Properties Menu Loaded`,
  MenuLoadedDomPatcher = `[ui-perf] Properties Menu Loaded - DomPatcher`,
}
